import React, {useState} from "react";
import {Box} from "@mui/system";
import {Divider, Typography} from "@mui/material";
import {useNavigate} from "react-router-dom";

import ButtonWidthDivider from "./UI/button/ButtonWidthDivider";
import {stages} from "../data/DataFromKuhniVerso";

const STEP_CARD_WIDTH = 473;

const stepHoverImagePosition = {
    1: {top: "180px", left: `${(-160 / STEP_CARD_WIDTH) * 100}%`},
    2: {top: "-135px", left: `${(450 / STEP_CARD_WIDTH) * 100}%`},
    3: {top: "265px", left: `${(-130 / STEP_CARD_WIDTH) * 100}%`},
    4: {top: "-200px", left: `${(355 / STEP_CARD_WIDTH) * 100}%`},
};

const MEDIA_MAX_1023 = "@media (max-width: 1023px)";
const MEDIA_MAX_760 = "@media (max-width: 760px)";
const MEDIA_MAX_599 = "@media (max-width: 599px)";
const MEDIA_MAX_400 = "@media (max-width: 400px)";

const STEP_TABLET_CIRCLE = 74;
const STEP_TABLET_GAP = 20;
const STEP_TABLET_STEP_PAD = 72.5;
const STEP_MOBILE_CIRCLE = 60;
const STEP_MOBILE_GAP = 16;

const stepTabletLineLeft = `calc(${STEP_TABLET_STEP_PAD}px + ${STEP_TABLET_CIRCLE / 2}px)`;
const stepMobileLineLeft = `calc(50% - ${(STEP_MOBILE_CIRCLE + STEP_MOBILE_GAP + STEP_CARD_WIDTH) / 2 - STEP_MOBILE_CIRCLE / 2}px)`;
const stepMobileLineLeftNoPad = `${STEP_MOBILE_CIRCLE / 2}px`;

const blockHeadingMobileSx = {
    [MEDIA_MAX_599]: {
        fontSize: "32px",
    },
};

const buttonWidthDividerMobile400ButtonSx = {
    lineHeight: 1,
    [MEDIA_MAX_400]: {
        width: "auto",
        minWidth: "unset",
        px: "14px",
        height: 42,
        minHeight: 42,
        fontSize: "16px",
    },
};

const buttonWidthDividerMobile400DecorSx = {
    [MEDIA_MAX_400]: {
        "& .MuiDivider-root": {
            width: "44px",
        },
        "& .child-box": {
            width: "20px",
            height: "20px",
            right: "-10px",
        },
        "&:hover .child-box": {
            width: "32px",
            height: "32px",
            right: "-16px",
        },
    },
};

export const KuhniHowItWorksSection = () => {
    const navigate = useNavigate();
    const [hoverId, setHoverId] = useState(null);

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                boxSizing: "border-box",
                borderRadius: "16px",
                padding: "0 40px",
                gap: "40px",
                width: "100%",
                height: "1745px",
                "& .MuiTypography-root": {
                    lineHeight: 1.3,
                },
                "@media (max-width: 1620px)": {
                    flexDirection: "column",
                },
                "@media (max-width: 1200px)": {
                    "& .MuiTypography-root": {
                        lineHeight: 1.2,
                    },
                },
                [MEDIA_MAX_1023]: {
                    height: "auto",
                    paddingLeft: 0,
                    paddingRight: 0,
                    "& .MuiTypography-root": {
                        lineHeight: 1.3,
                    },
                },
                [MEDIA_MAX_599]: {
                    padding: "0 16px",
                },
            }}
        >
            <Typography
                sx={{
                    fontSize: "40px",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    lineHeight: 1.2,
                    textAlign: "center",
                    padding: "0 20px",
                    "@media (max-width: 1450px)": {
                        fontSize: "28px",
                    },
                    [MEDIA_MAX_1023]: {
                        fontSize: "40px",
                        textAlign: "center",
                    },
                    ...blockHeadingMobileSx,
                    [MEDIA_MAX_599]: {
                        fontSize: "24px",
                        textAlign: "center",
                        padding: "0 20px",
                    },
                }}
            >
                Как <span style={{color: "#3B8BEC"}}>работает</span> сервис заказа мебели UpMe
            </Typography>

            <Box
                sx={{
                    height: "1630px",
                    width: "1060px",
                    position: "relative",
                    display: "flex",
                    justifyContent: "space-between",
                    flexDirection: "column",
                    alignItems: "center",
                    [MEDIA_MAX_1023]: {
                        width: "100%",
                        height: "auto",
                        gap: "80px",
                        alignItems: "flex-start",
                    },
                    [MEDIA_MAX_599]: {
                        gap: "20px",
                    },
                }}
            >
                <Divider
                    orientation="vertical"
                    sx={{
                        position: "absolute",
                        left: "50%",
                        top: 0,
                        height: "100%",
                        transform: "translateX(-50%)",
                        borderColor: (theme) => theme.palette.primary.main,
                        zIndex: 0,
                        [MEDIA_MAX_1023]: {
                            left: stepTabletLineLeft,
                            transform: "translateX(-50%)",
                        },
                        [MEDIA_MAX_760]: {
                            left: stepMobileLineLeft,
                        },
                        [MEDIA_MAX_599]: {
                            left: stepMobileLineLeftNoPad,
                            transform: "translateX(-50%)",
                            display: "none",
                        },
                    }}
                />

                <Box
                    sx={{
                        boxSizing: "border-box",
                        width: "790px",
                        bgcolor: (theme) => theme.palette.primary.lightGrey,
                        boxShadow: `1px 1px 12px 0px rgba(9, 88, 146, 0.16)`,
                        borderRadius: "16px",
                        padding: "20px",
                        gap: "20px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1,
                        "@media (max-width: 1200px)": {
                            padding: "14px",
                            gap: "14px",
                        },
                        [MEDIA_MAX_1023]: {
                            width: "100%",
                            padding: "20px 16px",
                            gap: "20px",
                        },
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: "28px",
                            fontWeight: 700,
                            textAlign: "center",
                            [MEDIA_MAX_599]: {
                                fontSize: "22px",
                            },
                        }}
                    >
                        Всё просто: вы редактируете кухонный шаблон под свои размеры
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: "17px",
                            fontWeight: 400,
                            width: "700px",
                            textAlign: "center",
                            [MEDIA_MAX_1023]: {
                                width: "100%",
                            },
                        }}
                    >
                        Наш конструктор — это шаблон кухни с набором готовых модулей (шкафов). Вы сами решаете, какой размер им задать. Система автоматически следит за размером кухни и совместимостью шкафов.
                    </Typography>
                </Box>

                {stages.map((el, i) => {
                    const number = i + 1;
                    return (
                        <Box
                            key={el.id}
                            sx={{
                                display: "flex",
                                gap: "20px",
                                alignItems: "center",
                                width: "100%",
                                flexDirection: number % 2 === 0 ? "row-reverse" : "row",
                                "@media (max-width: 1200px)": {
                                    display: "grid",
                                    gridTemplateColumns: "1fr auto 1fr",
                                    alignItems: "center",
                                    gap: "14px",
                                },
                                [MEDIA_MAX_1023]: {
                                    display: "grid",
                                    gridTemplateColumns: `${STEP_TABLET_CIRCLE}px 1fr`,
                                    alignItems: "center",
                                    columnGap: `${STEP_TABLET_GAP}px`,
                                    paddingLeft: `${STEP_TABLET_STEP_PAD}px`,
                                    paddingRight: `${STEP_TABLET_STEP_PAD}px`,
                                    boxSizing: "border-box",
                                    flexDirection: "unset",
                                    position: "relative",
                                    zIndex: 1,
                                },
                                [MEDIA_MAX_760]: {
                                    width: "fit-content",
                                    maxWidth: "100%",
                                    marginLeft: "auto",
                                    marginRight: "auto",
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                    gridTemplateColumns: `${STEP_MOBILE_CIRCLE}px minmax(0, ${STEP_CARD_WIDTH}px)`,
                                    columnGap: `${STEP_MOBILE_GAP}px`,
                                },
                                [MEDIA_MAX_599]: {
                                    display: "flex",
                                    flexDirection: "column-reverse",
                                    alignItems: "center",
                                    gap: "20px",
                                    width: "100%",
                                    maxWidth: "100%",
                                    marginLeft: 0,
                                    marginRight: 0,
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                },
                            }}
                        >
                            <Box
                                onMouseEnter={() => el.img && setHoverId(number)}
                                onMouseLeave={() => setHoverId(null)}
                                sx={{
                                    boxSizing: "border-box",
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "473px",
                                    bgcolor: (theme) => theme.palette.primary.lightGrey,
                                    border:
                                        hoverId === number
                                            ? (theme) => `1px solid ${theme.palette.primary.main}`
                                            : "1px solid transparent",
                                    boxShadow: `1px 1px 12px 0px rgba(9, 88, 146, 0.16)`,
                                    borderRadius: "16px",
                                    padding: "20px",
                                    gap: "10px",
                                    position: "relative",
                                    "@media (max-width: 1200px)": {
                                        gridColumn: number % 2 === 0 ? 3 : 1,
                                        justifySelf: number % 2 === 0 ? "start" : "end",
                                        width: "400px",
                                        padding: "14px",
                                        gap: "8px",
                                    },
                                    [MEDIA_MAX_1023]: {
                                        gridColumn: 2,
                                        gridRow: 1,
                                        width: "100%",
                                        justifySelf: "stretch",
                                        padding: "20px",
                                        gap: "10px",
                                    },
                                    [MEDIA_MAX_760]: {
                                        width: "100%",
                                        maxWidth: `${STEP_CARD_WIDTH}px`,
                                        padding: "14px",
                                        gap: "8px",
                                    },
                                    [MEDIA_MAX_599]: {
                                        width: "100%",
                                        maxWidth: "100%",
                                        gridColumn: "unset",
                                        gridRow: "unset",
                                        justifySelf: "stretch",
                                        padding: "16px",
                                        gap: "8px",
                                    },
                                }}
                            >
                                {hoverId === number ? (
                                    <Box
                                        sx={{
                                            height: "200px",
                                            minWidth: "250px",
                                            borderRadius: "8px",
                                            backgroundImage: `url(${el.img})`,
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "cover",
                                            position: "absolute",
                                            transform: number > 2 ? `rotate(-10deg)` : `rotate(10deg)`,
                                            ...stepHoverImagePosition[number],
                                        }}
                                    />
                                ) : null}
                                <Typography
                                    sx={{
                                        fontSize: "17px",
                                        fontWeight: 600,
                                        [MEDIA_MAX_599]: {
                                            fontSize: "16px",
                                        },
                                    }}
                                >
                                    {el.header}
                                </Typography>
                                <Box
                                    sx={{
                                        padding: "0 20px",
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "10px",
                                        "@media (max-width: 1200px)": {
                                            padding: "0 14px",
                                            gap: "8px",
                                        },
                                        [MEDIA_MAX_760]: {
                                            padding: "0 12px",
                                            gap: "6px",
                                        },
                                        [MEDIA_MAX_599]: {
                                            padding: "0 16px",
                                            gap: "8px",
                                        },
                                    }}
                                >
                                    {el.text.map((item) => (
                                        <Typography
                                            key={item.id}
                                            component="li"
                                            sx={{
                                                fontSize: "16px",
                                                fontWeight: 400,
                                                [MEDIA_MAX_760]: {
                                                    fontSize: "15px",
                                                },
                                                [MEDIA_MAX_599]: {
                                                    fontSize: "16px",
                                                },
                                            }}
                                        >
                                            {item.text}
                                        </Typography>
                                    ))}
                                </Box>
                            </Box>

                            <Box
                                sx={{
                                    width: "74px",
                                    height: "74px",
                                    borderRadius: "74px",
                                    bgcolor: (theme) => theme.palette.primary.main,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexShrink: 0,
                                    position: "relative",
                                    zIndex: 1,
                                    "@media (max-width: 1200px)": {
                                        gridColumn: 2,
                                        gridRow: 1,
                                        width: "60px",
                                        height: "60px",
                                        borderRadius: "60px",
                                    },
                                    [MEDIA_MAX_1023]: {
                                        gridColumn: 1,
                                        gridRow: 1,
                                        width: `${STEP_TABLET_CIRCLE}px`,
                                        height: `${STEP_TABLET_CIRCLE}px`,
                                        minWidth: `${STEP_TABLET_CIRCLE}px`,
                                        minHeight: `${STEP_TABLET_CIRCLE}px`,
                                        borderRadius: "50%",
                                        justifySelf: "center",
                                        position: "relative",
                                        zIndex: 1,
                                    },
                                    [MEDIA_MAX_760]: {
                                        width: `${STEP_MOBILE_CIRCLE}px`,
                                        height: `${STEP_MOBILE_CIRCLE}px`,
                                        minWidth: `${STEP_MOBILE_CIRCLE}px`,
                                        minHeight: `${STEP_MOBILE_CIRCLE}px`,
                                    },
                                    [MEDIA_MAX_599]: {
                                        width: "74px",
                                        height: "74px",
                                        minWidth: "74px",
                                        minHeight: "74px",
                                        alignSelf: "center",
                                        gridColumn: "unset",
                                        gridRow: "unset",
                                        zIndex: -1,
                                    },
                                    ...(number > 1
                                        ? {
                                            "&::before": {
                                                content: '""',
                                                display: "none",
                                                position: "absolute",
                                                left: "50%",
                                                bottom: "100%",
                                                transform: "translateX(-50%)",
                                                width: "1px",
                                                height: "24px",
                                                backgroundColor: (theme) => theme.palette.primary.main,
                                                [MEDIA_MAX_599]: {
                                                    display: "block",
                                                },
                                            },
                                        }
                                        : {}),
                                    ...(number <= stages.length
                                        ? {
                                            "&::after": {
                                                content: '""',
                                                display: "none",
                                                position: "absolute",
                                                left: "50%",
                                                top: "100%",
                                                transform: "translateX(-50%)",
                                                width: "1px",
                                                height: "24px",
                                                backgroundColor: (theme) => theme.palette.primary.main,
                                                [MEDIA_MAX_599]: {
                                                    display: "block",
                                                },
                                            },
                                        }
                                        : {}),
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: "34px",
                                        fontWeight: 700,
                                        color: "white",
                                    }}
                                >{`0${number}`}</Typography>
                            </Box>
                        </Box>
                    );
                })}

                <ButtonWidthDivider
                    onClick={() => navigate("/catalog")}
                    text={"Подобрать шаблон"}
                    width={276}
                    buttonSx={buttonWidthDividerMobile400ButtonSx}
                    sx={buttonWidthDividerMobile400DecorSx}
                />
            </Box>
        </Box>
    );
};

export default KuhniHowItWorksSection;

